import React from 'react'

import { Section } from '@factorialco/deprecated-design-system'
import { ProcurementTypeItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import CreateRequestTypeModal from 'modules/procurement/components/procurementTypes/CreateTypeModal'
import TypeItem from 'modules/procurement/components/procurementTypes/RequestTypeSettingsBlock/TypeItem'

interface Props {
  requestTypes: ProcurementTypeItemFragment[]
}

export const RequestTypeSettingsBlock = ({ requestTypes }: Props) => {
  const [detailModalOpen, setDetailModalOpen] = React.useState(false)

  return (
    <>
      <Section.List
        illustration="wallet"
        title={i18n.t('procurement.purchase_requests.settings.types.title')}
        description={i18n.t('procurement.purchase_requests.settings.types.description')}
        action={{
          label: i18n.t('procurement.purchase_requests.settings.types.actions.add'),
          onClick: () => setDetailModalOpen(true),
        }}
        paddingX={'s0'}
      >
        {requestTypes &&
          requestTypes.map((requestType) => (
            <TypeItem key={requestType.id} requestType={requestType} />
          ))}
      </Section.List>
      {detailModalOpen && (
        <CreateRequestTypeModal onClose={() => setDetailModalOpen(false)} hasFormsEnabled={false} />
      )}
    </>
  )
}
